<template>
  <div id="join">
    <loading-overlay v-if="loading"></loading-overlay>
    <!-- 操作 -->
    <!-- <h3>我的案例</h3> -->
    <!-- <List :list="list" :loading="loading" /> -->
    <div class="search">
      <el-input
        placeholder="请输入查找的档案编号"
        prefix-icon="el-icon-search"
        v-model.trim="formMore.Serial"
      ></el-input>
      <el-select
        ref="choose"
        v-model="typeCase"
        placeholder="更多筛选"
        @focus="moreSelect()"
      >
        <el-option
          v-for="item in typeList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-button type="warning" size="mini" @click="search()">搜索</el-button>
      <!-- <el-button @click="resFuntion">重置</el-button> -->
    </div>
    <el-table
      :data="tableData"
      :header-cell-style="{ textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }"
      style="width: 100%"
    >
      <el-table-column prop="reason" label="案由"></el-table-column>
      <el-table-column prop="consignor" label="委托人"></el-table-column>
      <el-table-column prop="litigant" label="当事人"></el-table-column>
      <el-table-column prop="undertake" label="承办律师"></el-table-column>
      <el-table-column prop="attorney" label="协助律师"></el-table-column>
      <el-table-column
        prop="receiptNumber"
        label="律所收案号"
      ></el-table-column>
      <el-table-column prop="court" label="承办法院"></el-table-column>
      <el-table-column prop="acceptCode" label="受理机构案号"></el-table-column>
      <el-table-column prop="quantity" label="卷宗数量"></el-table-column>
      <el-table-column prop="year" label="年份"></el-table-column>
      <el-table-column prop="casetype" label="案件类型"></el-table-column>
      <el-table-column
        prop="postTime"
        label="归档时间"
        :formatter="formatTime"
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        :formatter="formatStatus"
      ></el-table-column>
      <el-table-column label="功能" fixed="right" width="160">
        <template slot-scope="scope">
          <el-button
            slot="reference"
            plain
            size="small"
            type="success"
            v-if="scope.row.status == 1 && newConfirmApprove"
            @click="archiveApprove(scope.row)"
            >归档</el-button
          >
          <el-popconfirm
            title="是否确定驳回？"
            @onConfirm="back(scope.row)"
            @confirm="back(scope.row)"
            style="margin-left: 10px"
            v-if="scope.row.status == 1"
          >
            <el-button
              slot="reference"
              plain
              size="small"
              type="warning"
              v-if="newConfirmBack"
              >驳回</el-button
            >
          </el-popconfirm>
          <!-- <el-button
            type="success"
            plain
            size="small"
            @click="changeStatus(scope.row)"
            >通过</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes"
        :total="Total"
      ></el-pagination>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="Total"
      ></el-pagination>
    </div>
    <!--更多选择!-->
    <el-dialog
      title="更多筛选"
      :visible.sync="dialogMoreVisible"
      width="40%"
      center
      :show-close="true"
    >
      <el-form
        ref="formMore"
        :model="formMore"
        label-width="90px"
        style="min-height: 400px"
        :rules="rules"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="案由">
              <el-input
                class="select"
                v-model.trim="formMore.Reason"
                placeholder="请输入案由"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="年份" prop="Year">
              <el-input
                class="select"
                v-model.trim="formMore.Year"
                placeholder="请输入年份"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="委托人">
              <el-input
                class="select"
                v-model.trim="formMore.consignor"
                placeholder="请输入委托人"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="当事人">
              <el-input
                class="select"
                v-model.trim="formMore.litigant"
                placeholder="请输入当事人"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="承办律师">
              <el-input
                class="select"
                v-model.trim="formMore.undertake"
                placeholder="请输入承办律师"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="协助律师">
              <el-input
                class="select"
                v-model.trim="formMore.attorney"
                placeholder="请输入协助律师"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="律所收案号">
              <el-input
                class="select"
                v-model.trim="formMore.ReceiptNumber"
                placeholder="请输入律所收案号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="承办法院">
              <el-input
                class="select"
                v-model.trim="formMore.Court"
                placeholder="请输入承办法院"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="受理机构案号">
              <el-input
                class="select"
                v-model.trim="formMore.AcceptCode"
                placeholder="请输入受理机构案号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卷宗数量" prop="Quantity">
              <el-input
                class="select"
                v-model.trim="formMore.Quantity"
                placeholder="请输入卷宗数量"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="案件类型">
              <el-select
                v-model.trim="formMore.casetype"
                placeholder="请选择"
                class="select"
                clearable=""
              >
                <el-option
                  v-for="item in casetypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="状态">
              <el-select
                v-model.trim="formMore.Status"
                placeholder="请选择"
                class="select"
                clearable=""
              >
                <el-option
                  v-for="item in StatusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="归档时间" label-width="100px">
              <el-date-picker
                style="width: 60%"
                v-model.trim="formMore.Reviewtime"
                class="select"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="btn">
        <el-button type="primary" @click="search()">搜索</el-button>
      </div>
    </el-dialog>
    <!--归档-->
    <el-dialog
      title="归档"
      :visible.sync="dialogAchiveVisible"
      width="40%"
      center
      :show-close="true"
      @closed="closeForm('formAchive')"
    >
      <el-form
        ref="formAchive"
        :model="formAchive"
        label-width="90px"
        style="min-height: 400px"
        :rules="achiverules"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="归档位置" prop="Storage">
              <el-input
                class="select"
                v-model.trim="formAchive.Storage"
                placeholder="请输入归档位置"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="归档编号" prop="Serial">
              <el-input
                class="select"
                v-model.trim="formAchive.Serial"
                placeholder="请输入归档编号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="卷宗数量" prop="Quantity">
              <el-input
                class="select"
                v-model.trim="formAchive.Quantity"
                placeholder="请输入卷宗数量"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="年份" prop="Year">
              <el-input
                class="select"
                v-model.trim="formAchive.Year"
                placeholder="请输入年份"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="btn">
        <el-button type="primary" @click="approve('formAchive')"
          >通过</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
  
  <script>
import {
  ArchiveList,
  ChangeStatus,
  GetCaseTypes,
  ApproveArchive,
  BackArchive
} from '../../api/archive.js'

export default {
  name: 'newConfirm',
  // mixins: [],
  data() {
    var validateValue = (rule, value, callback) => {
      if (value === '' || value === null || value == undefined) {
        callback(new Error('请正确输入'))
      } else {
        callback()
      }
    }
    var isnum = (rule, value, callback) => {
      if (
        value === '' ||
        value === undefined ||
        isNaN(value) ||
        value.toString().replace(/\s*/g, '') != value
      ) {
        callback(new Error('请正确输入'))
      } else {
        callback()
      }
    }
    var quantity = (rule, value, callback) => {
      var number = /^[1-9][0-9]*$/
      if (!value) {
        callback(new Error('不能为空'))
      } else if (!number.test(value)) {
        callback(new Error('请输入正确数字')) //只能输入整数
      } else {
        callback()
      }
    }
    return {
      newConfirmBack: false,
      newConfirmApprove: false,
      list: [],
      loading: true,
      formMore: {
        Reason: '',
        Serial: '',
        consignor: '',
        litigant: '',
        undertake: '',
        attorney: '',
        ReceiptNumber: '',
        Court: '',
        AcceptCode: '',
        Quantity: null,
        Year: null,
        Storage: '',
        casetype: '',
        Status: '',
        Reviewtime: []
      },
      formAchive: {
        id: '',
        Storage: '',
        Serial: '',
        Quantity: null,
        Year: null,
      },
      isPage: true,
      typeCase: '',
      typeList: [],
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      Total: 0,
      dialogFormVisible: false,
      dialogMoreVisible: false,
      dialogAchiveVisible: false,
      dialogFormTitle: '',
      form: {},
      enterForm: {},
      value2: '',
      options: [],
      casetypes: [],
      StatusList: [
        { id: '0', name: '已归档' },
        { id: '1', name: '待归档' },
        { id: '2', name: '已借出' },
        { id: '3', name: '拒绝归档' },
        { id: '4', name: '已归还' }
      ],
      rules: {
        Year: [{ validator: isnum, trigger: 'blur' }],
        Quantity: [{ validator: isnum, trigger: 'blur' }]
      },
      achiverules: {
        Storage: [
          { validator: validateValue, trigger: 'blur', required: true }
        ],
        Serial: [{ validator: validateValue, trigger: 'blur', required: true }],
        Quantity: [
          { validator: quantity, trigger: 'change', required: true }
        ],
        Year: [{ validator: quantity, trigger: 'change', required: true }]
      },
      loading: true
    }
  },
  mounted() {
    this.newConfirmBack = this.$store.state.rolesname.includes('newConfirmBack')
    this.newConfirmApprove =
      this.$store.state.rolesname.includes('newConfirmApprove')
    this.search()
    this.CaseTypes()
  },
  components: {
    // List
  },
  methods: {
    search() {
      this.loading = true
      let Params = {
        Serial: this.formMore.Serial,
        Status: this.formMore.Status,
        consignor: this.formMore.consignor,
        Reason: this.formMore.Reason,
        litigant: this.formMore.litigant,
        undertake: this.formMore.undertake,
        attorney: this.formMore.attorney,
        ReceiptNumber: this.formMore.ReceiptNumber,
        Court: this.formMore.Court,
        AcceptCode: this.formMore.AcceptCode,
        Quantity: this.formMore.Quantity,
        Year: this.formMore.Year,
        Storage: this.formMore.Storage,
        casetype: this.formMore.casetype,
        Reviewtime: this.formMore.Reviewtime,
       
        distinct: 'newConfirm',
        rows: this.pageSize,
        page: this.currentPage
      }
      ArchiveList(Params)
        .then((res) => {
          this.loading = false
          if (res.data.status != 'success') {
            this.$message.error(res.data.message)
            return
          }
          this.tableData = res.data.data
          this.Total = res.data.total
          // this.
        })
        .catch(() => {
          this.loading = false
          this.$message.error('查询出错')
        })
    },
    //案件类型
    CaseTypes() {
      GetCaseTypes()
        .then((res) => {
          if (res.data.status != 'success') {
            this.$message.error(res.data.message)
            return
          }
          this.casetypes = res.data.data
        })
        .catch(() => {
          this.$message.error('获取案件类型出错')
        })
    },
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.search()
    },
    handleClick() {
      this.dialogFormVisible = true
    },
    changeStatus(row, status) {
      this.loading = true
      ChangeStatus({
        id: row.id,
        status: status
      })
        .then((res) => {
          this.loading = false
          if (res.data.status != 'success') {
            this.$message.error(res.data.message)
            return
          }
          this.$message.success('操作成功')
          this.search()
        })
        .catch(() => {
          this.loading = false
          this.$message.error('操作失败')
        })
    },
    //更多筛选
    moreSelect() {
      //更多选择
      this.$refs.choose.blur()
      this.dialogMoreVisible = true
    },
    //归档
    archiveApprove(row) {
      var form = JSON.parse(JSON.stringify(row))
      this.formAchive.id = form.id
      this.formAchive.Quantity = form.quantity
      this.formAchive.Year = form.year
      this.dialogAchiveVisible = true
    },
    //通过归档
    approve(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          ApproveArchive({
            id: this.formAchive.id,
            status: 0,
            Serial: this.formAchive.Serial,
            Storage: this.formAchive.Storage,
            Quantity:this.formAchive.Quantity,
            Year:this.formAchive.Year,
          })
            .then((res) => {
              this.loading = false
              this.dialogAchiveVisible = false
              if (res.data.status != 'success') {
                this.$message.error(res.data.message)
                return
              }
              this.$message.success('操作成功')
              this.search()
            })
            .catch(() => {
              this.loading = fasle
              this.$message.error('操作失败')
            })
        } else {
          this.$message.warning('请填入必填项')
          this.dialogVisible = true
          return false
        }
      })
    },
    //驳回归档
    back(row) {
      this.loading = true
      BackArchive({
        id: row.id,
        status: 3
      })
        .then((res) => {
          this.loading = false
          if (res.data.status != 'success') {
            this.$message.error(res.data.message)
            return
          }
          this.$message.success('操作成功')
          this.search()
        })
        .catch(() => {
          this.loading = false
          this.$message.error('操作失败')
        })
    },
    handleClose() {
      this.dialogFormVisible = false
    },
    // 关闭dialog时清空表单
    closeForm(formName) {
      this.$refs[formName].resetFields()
    },
    formatTime(row, column) {
      if (row[column.property] == null) {
        return null
      }
      const date = new Date(row[column.property])
      // return row[column.property].Format('yyyy-MM-dd HH:mm')
      var year = date.getFullYear()
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      var month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var seconds =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      // 拼接
      return (
        year +
        '-' +
        month +
        '-' +
        day +
        ' ' +
        hours +
        ':' +
        minutes +
        ':' +
        seconds
      )
    },
    formatStatus(row, column) {
      if (row[column.property] == 0) return '已归档'
      else if (row[column.property] == 3) return '拒绝归档'
      else if (row[column.property] == 1) return '待归档'
      else if (row[column.property] == 2) return '已借出'
      else if (row[column.property] == 4) return '已归还'
      else return ''
    },
    callOf() {
      this.dialogFormVisible = false
    }
  },
  computed: {
    total() {
      return this.tableData.length
      // return 9
    }
  }
}
</script>
  
  <style lang="less" scoped>
#join {
  // position: relative;
  .search {
    box-sizing: border-box;
    display: flex;
    padding: 24px;
    width: 100%;
    .el-input {
      width: 20%;
    }
    ::v-deep .el-input__inner {
      // width: 80% !important;
      // width: 300px;
      height: 45px;
      background-color: #fafafa;
      border: 0 !important;
    }
    .el-select {
      margin: 0 10px;
      width: 150px;
    }
  }
  .pagination {
    // position: absolute;
    // bottom: 40px;
    // right: 80px;
    margin: 20px 20px;
    display: flex;
    justify-content: space-between;
    .el-pagination {
      padding-right: 50px;
    }
  }
  .sel-input-all {
    width: 70%;
  }
  .all-input {
    width: 90%;
  }
  .select {
    width: 10vw;
    margin-bottom: 1rem;
  }
  .btn {
    width: 100%;
    text-align: center;
  }
}
</style>
  